import { Box } from '@mui/material';
import { renderColorBox } from '../../utils/cssStyles';
import { fDate } from '../../utils/formatTime';
import Iconify from '../iconify/Iconify';

const renderIcon = (value, icon) => (
    <Box>
        <Iconify icon={icon} width={13} height={13} /> {value || ''}
    </Box>
);

const category = {
    field: 'contractType',
    headerName: 'Category',
    type: 'customSelect',
    valueGetter: (params) => params.row.contractType || '',
    width: 200,
    renderCell: (params) => params.value && renderColorBox(params.value, 'secondary'),
};
const facility = {
    field: 'facility',
    headerName: 'Facility',
    minWidth: 100,
    flex: 1,
    renderCell: (params) => (
        <Box
            component="div"
            sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', }}
        >
            {params.value}
        </Box>
    ),
    type: 'customSelect',
};
const group = {
    field: 'group',
    headerName: 'Group',
    minWidth: 100,
    flex: 1,
    renderCell: (params) => (
        <Box
            component="div"
            sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', }}
        >
            {params.value}
        </Box>
    ),
    type: 'customSelect',
};
const vendor = {
    field: 'vendor',
    headerName: 'Vendor',
    minWidth: 100,
    flex: 1,
    renderCell: (params) => (
        <Box
            component="div"
            sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', }}
        >
            {params.value}
        </Box>
    ),
    type: 'customSelect',
};

const autoRenew = {
    field: 'autoRenew',
    headerName: 'Auto Renew',
    minWidth: 100,
    flex: 1,
    renderCell: (params) => (
        <Box
            component="div"
            sx={{
                wordWrap: 'break-word',
                flexGrow: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                m: 0.5,
            }}
        >
            {params.value}
        </Box>
    ),
    type: 'customSelect',
}

const paymentTerms = {
    field: 'paymentTerms',
    headerName: 'Payment Terms',
    minWidth: 100,
    flex: 1,
    type: 'customSelect',
}

const invoiceEvery = {
    field: 'invoiceEvery',
    headerName: 'Invoice Every',
    minWidth: 100,
    flex: 1,
    type: 'customSelect',
}

const starts = {
    field: 'startDate',
    headerName: 'Starts',
    minWidth: 100,
    flex: 1,
    type: 'customDate',
    renderCell: (params) => params.value ?
        renderIcon(`${fDate(params.value)} EST`, 'material-symbols:calendar-today-outline')
        : null,
    valueGetter: (params) => params.value ? new Date(params.value).getTime() : 0,
}

const ends = {
    field: 'endDate',
    headerName: 'Ends',
    minWidth: 100,
    flex: 1,
    type: 'customDate',
    renderCell: (params) => params.value ?
        renderIcon(`${fDate(params.value)} EST`, 'material-symbols:calendar-today-outline')
        : null,
    valueGetter: (params) => params.value ? new Date(params.value).getTime() : 0,
}
const terminationEffectiveDate = {
    field: 'terminationEffectiveDate',
    headerName: 'Term. Date',
    minWidth: 100,
    flex: 1,
    type: 'customDate',
    renderCell: (params) => params.value ?
        renderIcon(`${fDate(params.value)} EST`, 'material-symbols:calendar-today-outline')
        : null,
    valueGetter: (params) => params.value ? new Date(params.value).getTime() : 0,
}

const terminationFutureDate = {
    field: 'terminationEffectiveDate',
    headerName: 'Future Term. Date',
    minWidth: 100,
    flex: 1,
    type: 'customDate',
    renderCell: (params) => params.value ?
        renderIcon(`${fDate(params.value)} EST`, 'material-symbols:calendar-today-outline')
        : null,
    valueGetter: (params) => params.value ? new Date(params.value).getTime() : 0,
}

const termination = {
    field: 'isTerminated',
    headerName: 'Termination',
    minWidth: 100,
    flex: 1,
    type: 'customSelect',
    valueGetter: (t) => t.value ? 'yes' : 'no',
    renderCell: (t) => t.value,

}

const addedBy = {
    field: 'addedBy',
    headerName: 'Added By',
    minWidth: 100,
    flex: 1,
    type: 'customSelect',
}
const addedOn = {
    field: 'dateAdded',
    headerName: 'Added On',
    minWidth: 100,
    flex: 1,
    type: 'customDate',
    renderCell: (params) => params.value ?
        renderIcon(`${fDate(params.value)} EST`, 'material-symbols:calendar-today-outline')
        : null,
    valueGetter: (params) => params.value ? new Date(params.value).getTime() : 0,
}
const ACTIVE = [
    category,
    facility,
    group,
    vendor,
    autoRenew,
    paymentTerms,
    invoiceEvery,
    starts,
    ends,
    terminationFutureDate,
    addedBy,
    addedOn,
];


const TERMINATED = [
    category,
    facility,
    group,
    vendor,
    autoRenew,
    paymentTerms,
    invoiceEvery,
    starts,
    ends,
    terminationEffectiveDate,
    addedBy,
    addedOn,
];


const PREV_OWNER = [
    category,
    facility,
    group,
    vendor,
    autoRenew,
    paymentTerms,
    invoiceEvery,
    starts,
    ends,
    termination,
    terminationEffectiveDate,
    addedBy,
    addedOn,
];

const RENEW = [
    category,
    facility,
    group,
    vendor,
    autoRenew,
    paymentTerms,
    invoiceEvery,
    starts,
    ends,
    termination,
    terminationEffectiveDate,
    addedBy,
    addedOn,
];

export { ACTIVE, PREV_OWNER, RENEW, TERMINATED };
